const state = {
  userInfo: null
}

const mutations = {
  addUserInfo(state, userInfo) {
    state.userInfo = userInfo;
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js